import { EyeOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';

import { Button, StatusTag } from '../../../../components/index';

export function anchoringColumns(
  onSelectItem: (item: any) => void
): ColumnsType<Record<string, any>> {
  return [
    {
      title: 'Nome do fundeio',
      key: 'name',
      width: '25%',
      render: (_: any, record: any) => <span>{record.name}</span>,
    },
    {
      title: 'Área do porto',
      key: 'port_area',
      dataIndex: 'port_area',
      width: '15%',
      render: (_: any, record: any) => (
        <StatusTag>
          <span
            className={
              record.port_area === 'INTERNAL'
                ? 'neutral-blue'
                : 'neutral-orange'
            }
          >
            {record.port_area === 'INTERNAL' ? 'Interna' : 'Externa'}
          </span>
        </StatusTag>
      ),
    },
    {
      title: 'Estimativa de operação',
      key: 'operation_estimate',
      dataIndex: 'operation_estimate',
      width: '15%',
      render: (_: any, record: any) =>
        record.operation_estimate ? (
          <span>{record.operation_estimate} horas</span>
        ) : (
          <span
            style={{
              fontSize: '14px',
              color: 'var(--neutral_medium)',
              fontStyle: 'italic',
            }}
          >
            Não definida
          </span>
        ),
    },
    {
      title: 'Status',
      key: 'active',
      width: '15%',
      render: (_: any, record: any) => (
        <StatusTag>
          <span className={record.active ? 'green' : 'red'}>
            {record.active ? 'Ativo' : 'Inativo'}
          </span>
        </StatusTag>
      ),
    },
    {
      dataIndex: 'edit',
      align: 'center',
      render: (_: any, record: any) => (
        <Button
          icon={<EyeOutlined />}
          style={{ float: 'right' }}
          onClick={(e: any) => {
            e.stopPropagation();
            onSelectItem(record);
          }}
        />
      ),
    },
  ];
}
